import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Panel, Btn, Badge, Field, Input, Textarea, inputCls } from "@/admin/ui";

const STATUS_OPTS = ["active", "coming_soon", "in_development"];

export default function Brands() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/api/admin/brands").then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);

  const save = async (b) => {
    try { await api.put(`/api/admin/brands/${b.id}`, { name: b.name, tagline: b.tagline, description: b.description, status: b.status }); toast.success("Brand updated"); }
    catch (e) { toast.error(apiError(e)); }
  };
  const update = (id, k, v) => setItems((arr) => arr.map((b) => (b.id === id ? { ...b, [k]: v } : b)));

  return (
    <div data-testid="admin-brands">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">Brands</h1>
      <div className="grid gap-4 lg:grid-cols-2">
        {items.map((b) => (
          <Panel key={b.id} title={b.name} actions={<Badge status={b.status} />} testid={`brand-card-${b.id}`}>
            <div className="space-y-4">
              <Field label="Name"><Input value={b.name || ""} onChange={(e) => update(b.id, "name", e.target.value)} /></Field>
              <Field label="Tagline"><Input value={b.tagline || ""} onChange={(e) => update(b.id, "tagline", e.target.value)} /></Field>
              <Field label="Description"><Textarea rows={3} value={b.description || ""} onChange={(e) => update(b.id, "description", e.target.value)} /></Field>
              <Field label="Status">
                <select className={inputCls} value={b.status} onChange={(e) => update(b.id, "status", e.target.value)} data-testid={`brand-status-${b.id}`}>
                  {STATUS_OPTS.map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
                </select>
              </Field>
              <Btn onClick={() => save(b)} data-testid={`brand-save-${b.id}`}>Save</Btn>
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
